import actionTypes from 'SRC/modules/redux/actionTypes'
import initialState from 'SRC/modules/redux/initialState'

export const notificationsReducer = (state = initialState.notifications, action) => {
  switch (action.type) {
    case actionTypes.SET_NOTIFICATIONS:
      return {
        list: {
          ...state.list,
          elements: action.payload,
        }
      }
    case actionTypes.SET_NOTIFICATIONS_LOADING:
      return {
        list: {
          ...state.list,
          isLoading: action.payload,
        }
      }
    case actionTypes.SHOW_NOTIFICATIONS_MODAL:
      return {
        list: {
          ...state.list,
          showModal: action.payload,
        }
      }
    default:
      return state
  }
}
